import { Fragment, useState, useEffect } from 'react'
import { Dialog, DialogPanel, Menu, MenuButton, Transition, TransitionChild } from '@headlessui/react'
import {
  Bars3Icon,
  BellIcon,
  CalendarIcon,
  ChartPieIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  FolderIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon  
} from '@heroicons/react/24/outline'
import Requests from './Requests/index';
import Messages from './Messages/index';

import { ChevronDownIcon, MagnifyingGlassIcon,UserPlusIcon, EnvelopeIcon} from '@heroicons/react/24/solid'
import TopBar from '../global/TopBar';
import { useSelector } from 'react-redux';

let navigation = [
  { name: 'Requests', href: '#', icon: UserPlusIcon, current: true },
  { name: 'Messages', href: '#', icon: EnvelopeIcon, current: false }
]
const teams = [
  { id: 1, name: 'Heroicons', href: '#', initial: 'H', current: false },
  { id: 2, name: 'Tailwind Labs', href: '#', initial: 'T', current: false },
  { id: 3, name: 'Workcation', href: '#', initial: 'W', current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Notifications() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [productList, setProductList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [currentItem, setCurrentItem] = useState('Requests');
  const user  = useSelector((state) => state.auth.user);
  const [isExpanded, setIsExpanded] = useState(false);

  const isServiceProvider = user.isServiceProvider;
  
  const handleButtonClick = (name) => {
    setCurrentItem(name);
    setSidebarOpen(false);
    navigation = navigation.map(item => {
      if (item.name === name) {
        item.current = true;
      } else {
        item.current = false;
      }
      return item;
    }
    );
  }

  return (
    <>      
      <div>
        <Transition show={sidebarOpen} as={Fragment}>
          <Dialog className="relative z-50" onClose={setSidebarOpen}>
            <TransitionChild
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </TransitionChild>

            <div className="fixed inset-0 flex">
              <TransitionChild
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <DialogPanel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <TransitionChild
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button type="button" className="-m-2.5 p-2.5" onClick={() => setSidebarOpen(false)}>
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon className="h-10 w-10 rounded-full shadow-md shadow-pri-green-shadow text-pri-dark bg-pri-green" aria-hidden="true" />
                      </button>
                    </div>
                  </TransitionChild>
                  {/* Sidebar component, swap this element with another sidebar if you like */}
                  <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-sec-dark px-6 pb-4 ring-1 ring-white/10">
                    <div className="flex h-16 shrink-0 items-center">
                      <img
                        className="h-8 w-auto"
                        src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=500"
                        alt="Your Company"
                      />
                      <h1 className="text-left mtl-5 text-pri-white text-2xl md:text-4xl mb-5">Jingleez </h1>
                    </div>
                    <nav className="flex flex-1 flex-col">
                      <ul role="list" className="flex flex-1 flex-col gap-y-7">
                        <li>
                          <ul role="list" className="-mx-2 space-y-1">
                            {navigation.map((item) => (
                              <li key={item.name}>
                                <button
                                  onClick={() => handleButtonClick(item.name)}
                                  className={classNames(
                                  item.current
                                    ? 'text-pri-yellow'
                                    : 'text-pri-white hover:text-pri-dark hover:bg-pri-yellow',
                                  'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                                  )}
                                >
                                  <item.icon className="h-6 w-6 shrink-0" aria-hidden="true" />
                                  {item.name}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </Dialog>
        </Transition>
        <div className={`fixed inset-y-0 left-0 z-50 flex flex-col bg-gray-900 p-3 transition-width duration-300 ${isExpanded ? 'w-64' : 'w-20'}`}>
        <div className="flex items-center justify-between">
          <button type="button" className="text-gray-400" onClick={() => setSidebarOpen(true)}>
          <Bars3Icon className="lg:h-8 lg:w-8 h-6 w-6 text-pri-yellow size-4" aria-hidden="true" />
          </button>
        </div>
        <nav className="mt-5 flex-1 space-y-1">
          <ul>
          {navigation.map((item) => (
            <li key={item.name} className="relative group">
              <button
                onClick={() => handleButtonClick(item.name)}
                className={classNames(
                item.current
                  ? 'text-pri-yellow'
                  : 'text-pri-white hover:text-pri-dark hover:bg-pri-yellow',
                'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold mt-4'
                )}
              >
                <item.icon className="h-6 w-6 shrink-0" aria-hidden="true" />
                {isExpanded && <span>{item.name}</span>}
              </button>
              {!isExpanded && (
                <span className="absolute left-full hidden group-hover:block bg-pri-yellow font-bold text-pri-dark text-xs rounded-md py-1 px-2">
                  {item.name}
                </span>
              )}
            </li>
          ))}

          </ul>
        </nav>
      </div>
        <div className="lg:pl-0 static">
        <TopBar /> 
        </div>
        <div className="px-4 sm:px-6 lg:px-8 py-4 md:py-0">
        {currentItem === 'Requests' ? <Requests /> : currentItem === 'Messages' ? <Messages /> : null}
        </div>
      </div>
    </>
  )
}
